// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "index" + "-" + "325c2aaa4ec1cd453001" + ".css";
};